<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<wr-navbar
  [appName]="appName"
  [appShortName]="appShortName"
  [error]="errorMessage"
  [showProfile]="false"
  [showSettings]="false"
  [showAppInfo]="false"
  [replaceUserIconWithName]="true"
  [defaultAppIconName]="defaultAppIconName"
  [homeAppName]="homeAppName"
  [showOptions]="showOptions"
  (viewAllApps)="openAllApps()"
>
</wr-navbar>
